export default "__VITE_ASSET__Dx_x$x4D__";